import { FC } from 'react';

import { formatTime } from '../utils/formatTime';

/** Time marker component for start/end positions */
export const TimeMarker: FC<{ position: string; time: number }> = ({ position, time }) => (
  <div
    className="absolute inset-y-0 my-auto -translate-x-1/2 flex flex-col items-center"
    style={{ left: position }}
    aria-hidden="true"
  >
    <div className="w-0.5 h-4 bg-amber-400 rounded-full shadow-sm shadow-amber-400/50" />
    <span className="absolute -bottom-5 text-[9px] font-medium text-amber-300 whitespace-nowrap">
      {formatTime(time)}
    </span>
  </div>
);
